module.exports = __webpack_public_path__ + "static/media/zuhaira-mcgill.b213cf19.md";